import { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { getSeoDataApi } from "../../../../src/api/seo/seo";
import { getFooter } from "../../../actions/home/footerAction";
import { Helmet } from "react-helmet";
import { getHomepage } from "../../../actions/home/homepageActions";
import { getMenuImage } from "../../../actions/home/menuImageAction";
import { getSocial } from "../../../actions/home/socialAction";
import { getAboutUs } from "../../../actions/home/aboutAction";
import { getMealDeal } from "../../../actions/home/mealDealAction";
import { getGallery } from "../../../actions/home/galleryAction";
import { getSignup } from "../../../actions/home/signupAction";
import { getFeedBack } from "../../../actions/home/feedBackAction";
import { getReview } from "../../../actions/home/reviewAction";
import { getMainTableBooking } from "../../../actions/home/mainTableBookingAction";
import { connect } from "react-redux";
import { getPromotionStatusDetail } from "../../../actions/promotion/promotion";
import { getBranchStatusDetail } from "../../../actions/ourBranch/ourBranch";
import { getGalleryStatusDetail } from "../../../actions/galleryGrid/galleryGrid";
// import axios from "axios";
import "./leadFormStyle.scss";
import { franchiseLeadForm } from "../../../actions/franchiseleadform/franchiseleadForm";
// import { useNavigate } from "react-router-dom";

const FranchiseForm = ({
    response,
    getFooter,
    getSeoDataApi,
    franchiseLeadForm,
    footer,
}) => {
    const [seoData, setSeoData] = useState();
    const [formSubmit, setFormSubmit] = useState(false);
    const canonicalUrl = `${window.location.origin}${window.location.pathname}`;
    const [showToast, setShowToast] = useState(false);

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("First Name is required"),
        lastName: Yup.string().required("Last Name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        phone: Yup.string().required("Phone is required"),
        location: Yup.string().required("Location is required"),
    });

    useEffect(() => {
        if (response?.status) {
            const postData = {
                domain: window.location.hostname,
            };
            getFooter(postData);
        }
    }, [response]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiResponse = await getSeoDataApi();
                if (apiResponse?.data?.status === false) {
                    console.error("Error fetching sitemap data:", apiResponse.data.message);
                } else {
                    setSeoData(apiResponse.data.message);
                }
            } catch (error) {
                console.error("Error fetching sitemap data:", error);
            }
        };
        fetchData();
    }, []);

    const handleSubmit = (data, { resetForm }) => {
        const formData = {
            domain: window.location.hostname,
            first_name: data.firstName,
            lastName: data.lastName,
            email: data.email,
            phone: data.phone,
            location: data.location,
            interest: data.interest,
        };
        franchiseLeadForm(formData);
        setShowToast(true);
        setFormSubmit(true);
        resetForm();
        setTimeout(() => setShowToast(false), 3000);
    };

    if (footer) {
        console.log("footer =>", footer?.data?.franchise_details?.description);
    }
    return (
        <>
            <Helmet>
                <link rel="canonical" href={canonicalUrl} />
                {seoData?.title?.Help ? (
                    <title>{seoData.title.Help}</title>
                ) : (
                    <title>Fusion Kitchen | Become Franchise </title>
                )}
            </Helmet>
            <Helmet>
                <meta name="robots" content={seoData?.meta?.Help?.robots} />
                <meta name="description" content={seoData?.meta?.Help?.description} />
                <meta name="keywords" content={seoData?.meta?.Help?.keywords} />
            </Helmet>
            <div className="py-5 px-4 cw-leadform">
                <div className="text-center mb-4 cw-main-center">
                    {footer?.data?.franchise_details && (
                        <div className="txt-content">
                            <h2 className="text-secondary text-center">Franchise</h2>
                            <div className="txt-content">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: footer?.data?.franchise_details?.description,
                                    }}
                                />
                            </div>
                            <hr className="border border-2 border-danger w-100" />
                        </div>
                    )}
                </div>
                <Formik
                    initialValues={{
                        firstName: "",
                        lastName: "",
                        email: "",
                        phone: "",
                        interest: "",
                        location: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        errors,
                        isValid, dirty,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit} className="form-width">
                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="firstName" className="mb-3">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="firstName"
                                            value={values.firstName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.firstName && !!errors.firstName}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.firstName}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group controlId="lastName" className="mb-3">
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="lastName"
                                            value={values.lastName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.lastName && !!errors.lastName}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.lastName}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="email" className="mb-3">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.email && !!errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group controlId="phone" className="mb-3">
                                        <Form.Label>Phone</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="phone"
                                            value={values.phone}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.phone && !!errors.phone}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.phone}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Col xs={12} sm={12} md={12}>
                                <Form.Group controlId="formLocation">
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="location"
                                        name="location"
                                        placeholder="Enter your location"
                                        value={values.location}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid={touched.location && !!errors.location}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.location}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Form.Group controlId="interest" className="mb-3 mt-3">
                                <Form.Label>
                                Any other comments or questions? (Optional)
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="interest"
                                    value={values.interest}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.interest && !!errors.interest}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.interest}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <div className="btn-div">
                                <Button
                                    className="cw-register"
                                    variant="dark"
                                    type="submit"
                                    disabled={!isValid || !dirty}
                                >
                                    Register
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
            <div aria-live="polite" aria-atomic="true" className="position-relative">
                <div
                    className="toast-container p-3"
                    style={{
                        position: "fixed",
                        top: "100px",
                        right: "0px",
                    }}
                >
                    <div
                        className={`toast ${showToast ? "show" : "hide"}`}
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        onAnimationEnd={() => setShowToast(false)}
                    >
                        <div className="toast-header">
                            <strong className="me-auto text-success">Success</strong>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowToast(false)}
                            ></button>
                        </div>
                        <div className="toast-body text-success">
                            Thank you! Your enquiry has been submitted.
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    response: state.homepage?.response,
    footer: state.footer.response,
});

const mapDispatchToProps = {
    getSeoDataApi,
    getHomepage,
    getFooter,
    getSocial,
    getMealDeal,
    getAboutUs,
    getGallery,
    getSignup,
    getReview,
    getFeedBack,
    getMainTableBooking,
    getMenuImage,
    getPromotionStatusDetail,
    getBranchStatusDetail,
    getGalleryStatusDetail,
    franchiseLeadForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(FranchiseForm);